import 'babel-polyfill';
import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";
import Pages from "layouts/Pages.jsx";

import Dashboard from "layouts/Dashboard.jsx";
import UserDashboard from "layouts/UserDashboard";
import "assets/scss/material-dashboard-pro-react.css?v=1.3.0";
import ProtectedRoute from "./ProtectedRoute";
import NotFound from "./NotFound";
import { Provider } from 'react-redux';
import store from "store/";
import RevealPage from "views/Pages/Reveal.jsx";
import ServiceInterval from './qlikAuth';

const hist = createBrowserHistory();
ReactDOM.render(
  <React.Fragment>
    <ServiceInterval />
    <Provider store={store}>
      <Router history={hist}>
        <Switch>
          {/* {indexRoutes.map(prop => {
            <ProtectedRoute path={prop.path} component={Dashboard} />;
          })} */}
          <ProtectedRoute path="/dashboard" component={Dashboard} />
          <ProtectedRoute path="/userProfile" component={UserDashboard} />
          <ProtectedRoute
            path="/audiences/editAudiences/:id"
            component={Dashboard}
          />
          <ProtectedRoute path="/audiences/createAudiences" component={Dashboard} />
          <ProtectedRoute path="/audiences" component={Dashboard} />
          <ProtectedRoute path="/build-audience" component={Dashboard} />
          <ProtectedRoute path="/lists" component={Dashboard} />
          <ProtectedRoute path="/automations" component={Dashboard} />
          <ProtectedRoute path="/deliveries" component={Dashboard} />
          <ProtectedRoute path="/ask-ai/" component={Dashboard} />
          <ProtectedRoute path="/querytool" component={Dashboard} />
          <ProtectedRoute path="/maps" component={Dashboard} />
          <ProtectedRoute path="/querybuilder" component={Dashboard} />
          <ProtectedRoute path="/querybuilderStyles" component={Dashboard} />
          <ProtectedRoute
            path="/insights/customerportfolio"
            component={Dashboard}
          />

          <ProtectedRoute
            path="/templatebuilder/subscription"
            component={Dashboard}
          />
          <ProtectedRoute
            path="/templatebuilder/newsletter"
            component={Dashboard}
          />
          <ProtectedRoute path="/calendar" component={Dashboard} />
          <ProtectedRoute path="/campaigns" component={Dashboard} />
          <ProtectedRoute path="/upload" component={Dashboard} />
          <ProtectedRoute path="/kickbox" component={Dashboard} />
          <ProtectedRoute path="/about" component={Dashboard} />
          <ProtectedRoute path="/allresources" component={Dashboard} />
          <ProtectedRoute path="/resources/datasources" component={Dashboard} />
          <ProtectedRoute path="/resources/dataprocessing" component={Dashboard} />
          <ProtectedRoute path="/resources/rules" component={Dashboard} />
          <ProtectedRoute path="/resources/datamodel" component={Dashboard} />
          <ProtectedRoute path="/resources/stmap" component={Dashboard} />
          <ProtectedRoute path="/resources/glossary" component={Dashboard} />
          <Route path="/secret/reveal" component={RevealPage} />
          <Route path="/" component={Pages} />
          <Route component={NotFound} />
        </Switch>
      </Router>
    </Provider>
  </React.Fragment>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js